import components from './components.js';
import workbooks from './workbooks.js';
import globalSettings from './global-settings';

export default {
    components,
    workbooks,
    globalSettings
};
